import { AvatarService } from 'ngx-avatars';

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import { colorIsDark } from '@lib/common/helpers';

@Component({
  selector: 'sn-avatar',
  templateUrl: './avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'sn-avatar' },
})
export class SnAvatarComponent implements OnChanges {
  @Input()
  public src: string;

  @Input()
  public name: string;

  @Input()
  public value: string;

  @Input()
  public size = 40;

  @Input()
  public initialsSize = 2;

  @Input()
  public textSizeRatio = 2.5;

  @Input()
  public bgColor: string;

  public avatarBgColor: string;
  public avatarFgColor: string;

  constructor(private readonly _avatarService: AvatarService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    this._updateColors();
  }

  private _updateColors(): void {
    const avatarText = this.name || this.value;

    this.avatarBgColor = this.bgColor || this._avatarService.getRandomColor(avatarText);
    this.avatarFgColor = colorIsDark(this.avatarBgColor)
      ? 'rgba(255, 255, 255, .87)'
      : 'rgba(0, 0, 0, .87)';
  }
}
